var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imagesLoaded)?_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series}}):_vm._e(),_vm._v(" "),(1===2)?_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('pre',[_vm._v(_vm._s(_vm.pages))])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('pre',[_vm._v(_vm._s(_vm.blobs))])])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }